import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import Azure1 from '../../../assets/images/azure-1.png';
import Azure2 from '../../../assets/images/azure-2.png';
import AWS1 from '../../../assets/images/aws-1.png';
import AWS2 from '../../../assets/images/aws-2.png';
import Gcloud1 from '../../../assets/images/g-cloud-1.png';
import Gcloud2 from '../../../assets/images/g-cloud-2.png';
import Synology1 from '../../../assets/images/synology-1.png';
import Synology2 from '../../../assets/images/synology-2.png';
import Dell1 from '../../../assets/images/dell-1.png';
import Dell2 from '../../../assets/images/dell-2.png';
import OpenAI1 from '../../../assets/images/openai1.png';
import OpenAI2 from '../../../assets/images/openai2.png';

import ITMlogo from '../../../assets/images/itmonkeys-logo-transparent.png';

const Footer: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [hoveredLogo, setHoveredLogo] = useState<string | null>(null);
  
  const currentLanguage = i18n.language;
  const urlPrefix = currentLanguage === 'en' ? '/en' : '';

  const logos = [
    { name: 'Azure',     defaultSrc: Azure1,     hoverSrc: Azure2,     url: 'https://azure.microsoft.com/fr-fr' },
    { name: 'AWS',       defaultSrc: AWS1,       hoverSrc: AWS2,       url: 'https://aws.amazon.com/' },
    { name: 'Cloud',     defaultSrc: Gcloud1,    hoverSrc: Gcloud2,    url: 'https://cloud.google.com/' },
    { name: 'Synology',  defaultSrc: Synology1,  hoverSrc: Synology2,  url: 'https://www.synology.com/' },
    { name: 'Dell',      defaultSrc: Dell1,      hoverSrc: Dell2,      url: 'https://www.dell.com/' },
    { name: 'OpenAI',    defaultSrc: OpenAI1,    hoverSrc: OpenAI2,    url: 'https://openai.com/' },
  ];

  return (
    <div className="footer">
      <div className="technologies-container">
        <div className="technologies-banner">
          <h3>{t('footer.technologies', { defaultValue: 'TECHNOLOGIES' })}</h3>
          <div className="logo-container">
            {logos.map((logo) => (
              <a 
                key={logo.name} 
                href={logo.url} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <img
                  src={hoveredLogo === logo.name ? logo.hoverSrc : logo.defaultSrc}
                  alt={logo.name}
                  onMouseEnter={() => setHoveredLogo(logo.name)}
                  onMouseLeave={() => setHoveredLogo(null)}
                  className="technology-logo"
                />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="footer-main">
        <div className="footer-col footer-col-left">
          <div className="footer-logo">
            <img src={ITMlogo} alt="IT Monkeys Logo" />
          </div>
          <div className="footer-text">
          </div>
        </div>

        <div className="footer-col footer-col-second">
          <h4>{t('footer.cloudServices', { defaultValue: 'NextGen Cloud' })}</h4>
          <ul className="footer-links">
            <li><a href={`${urlPrefix}/cloudmigration`}>{t('footer.privateCloud', { defaultValue: 'Cloud privé' })}</a></li>
            <li><a href={`${urlPrefix}/cloudadmin`}>{t('footer.cloudMigration', { defaultValue: 'Migration vers le cloud' })}</a></li>
            <li><a href={`${urlPrefix}/secureteleworking`}>{t('footer.cloudInfrastructure', { defaultValue: 'Conception d\'infrastructure cloud' })}</a></li>
            <li><a href={`${urlPrefix}/privatecloud`}>{t('footer.cloudAdmin', { defaultValue: 'Administration systèmes cloud' })}</a></li>
          </ul>
        </div>

        <div className="footer-col footer-col-third">
          <h4>{t('footer.cybersecurity', { defaultValue: 'NextGen Cybersecurity' })}</h4>
          <ul className="footer-links">
            <li><a href={`${urlPrefix}/cyberaudit`}>{t('footer.securityAudit', { defaultValue: 'Audit de sécurité' })}</a></li>
            <li><a href={`${urlPrefix}/cyberincident`}>{t('footer.incidentResponse', { defaultValue: 'Réponse aux incidents' })}</a></li>
            <li><a href={`${urlPrefix}/sentinel`}>{t('footer.dataLeaksSentinel', { defaultValue: 'Data Leaks Sentinel' })}</a></li>
          </ul>
          
          <div className="mobile-only">
            <h4 className="itm-academy-header">{t('footer.itmAcademy', { defaultValue: 'IT Monkeys Academy' })}</h4>
            <ul className="footer-links itm-academy-list">
              <li><a href={`${urlPrefix}/azure-fundamentals`}>{t('footer.azureFundamentals', { defaultValue: 'Azure Cloud Fundamentals' })}</a></li>
              <li><a href={`${urlPrefix}/azure-admin`}>{t('footer.azureAdmin', { defaultValue: 'Azure Cloud Administration' })}</a></li>
              <li><a href={`${urlPrefix}/azure-security`}>{t('footer.azureSecurity', { defaultValue: 'Azure Security & Architecture' })}</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-col footer-col-fourth desktop-only">
          {/* <h4>{t('footer.cyberNews', { defaultValue: 'Actualités Cyber' })}</h4>
          <ul className="footer-links">
            <li><a href="/cyberguerre">{t('footer.cyberwar', { defaultValue: 'Cyberguerre' })}</a></li>
          </ul> */}
          <h4 className="itm-academy-header">{t('footer.itmAcademy', { defaultValue: 'IT Monkeys Academy' })}</h4>
          <ul className="footer-links itm-academy-list">
            <li><a href={`${urlPrefix}/azure-fundamentals`}>{t('footer.azureFundamentals', { defaultValue: 'Azure Cloud Fundamentals' })}</a></li>
            <li><a href={`${urlPrefix}/azure-admin`}>{t('footer.azureAdmin', { defaultValue: 'Azure Cloud Administration' })}</a></li>
            <li><a href={`${urlPrefix}/azure-security`}>{t('footer.azureSecurity', { defaultValue: 'Azure Security & Architecture' })}</a></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom-bar">
        <div className="footer-bottom-bar-content">
          <div className="copyright">&copy; IT Monkeys 2025</div>
          <a href={`${urlPrefix}/legal`}>{t('footer.legalNotice', { defaultValue: 'Mentions légales' })}</a>
        </div>
      </div>
    </div>
  );
};

export default Footer;